import { io } from "socket.io-client";
import { API_SOCKET_URL } from "../config";

var SOCKET_URL = process.env.REACT_APP_SOCKET_URL || API_SOCKET_URL;

console.log("Socket URL:", SOCKET_URL);

let socket = null;

export const connectSocket = () => {
  if (socket) {
    disconnectSocket(); // Ensure clean reconnection
  }

  const authToken = sessionStorage.getItem("authToken");
  console.log("Auth Token:", authToken);

  socket = io(SOCKET_URL, {
    transports: ["websocket"], // Prefer WebSocket over polling
    reconnection: true,
    reconnectionAttempts: 5,
    timeout: 30000, 
    reconnectionDelay: 2000,
    secure: true,
    query: {
      token: authToken,
    },
    extraHeaders: {
      Authorization: `Bearer ${authToken}`, // 🔹 Pass the token correctly
    },
  });

  socket.on("connect", () => {
    console.log("✅ Socket connected:", socket.id);
  });

  socket.on("connect_error", (error) => {
    console.error("❌ Socket connection error:", error);
    sessionStorage.removeItem("authToken");
  });

  socket.on("disconnect", (reason) => {
    console.log("⚠️ Socket disconnected:", reason);
  });

  socket.on("receive_message", (message) => {
    console.log("📩 New message received:", message);
  });

  socket.on("reconnect_attempt", (attempt) => {
    console.log(`🔄 Attempting to reconnect... (${attempt})`);
  });
};

export const getSocket = () => {
  if (!socket) {
    console.warn("⚠️ Socket not initialized. Call connectSocket() first.");
  }
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    console.log("🔌 Socket disconnected");
  }
};

export const reconnectSocket = () => {
  disconnectSocket();
  connectSocket();
};
